/**
 * クラス名：板金子部品工程選択
 * 説明：板金子部品工程選択ファイルである。
 * 作成者：ナンス
 * 作成日：2023/03/01
 * バージョン：1.0
 */
import React, { useEffect, useState, useImperativeHandle, forwardRef, useRef } from 'react';

import { initProcessSelect, patternPage } from '../common/Common';
import ProcessPatternForm from '../parameter/parent/processPattern/ProcessPatternForm';
import { getDeviceInfo, getProcessInfo, updateUserSetting } from '../common/CommonAPI';
import { ProcessDetailGroup, ServiceClass, WorkType } from '../common/enums';
import { IQ3ClassNumber } from '../common/Constant';

const IQ3KouteiSentaku = forwardRef((props, ref) => {
  const [listData, setListData] = useState([]);
  const [processSelectedData, setProcessSelectedData] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [kouteiSentakuPatternNo, setKouteiSentakuPatternNo] = useState([]);
  const [kouteiSentakuPatternList, setKouteiSentakuPatternList] = useState([]);
  const [iq3List, setIQ3List] = useState([]);
  const [deviceMasterInfo, setDeviceMasterInfo] = useState([]);
  const [processMasterInfo, setProcessMasterInfo] = useState([]);
  const [clientInfo, setClientInfo] = useState([]);
  const [currentRecordIndex, setCurrentRecordIndex] = useState(0);

  const patternformRef = useRef();

  let parameters = props?.selectedDataDetail?.estimateProducts?.calcParameters?.parameters;

  useEffect(() => {
    if (props?.tabOpen || props?.pmxMode) {
      getProcesssPatternInfo();
      let iq3List = props.iQ3DataLst == undefined ? [] : props.iQ3DataLst;
      let iq3List_SelectBoxData = [];
      for (let i = 0; i < iq3List?.length; i++) {
        iq3List_SelectBoxData.push({ label: 'No.' + iq3List[i].no + '　' + iq3List[i].name, value: iq3List[i].no });
      }
      setIQ3List(iq3List_SelectBoxData);
      let curRowNo = props?.currentRecordNo ? props?.currentRecordNo : 1;
      for (let i = 0; i < props.selectedDataDetail?.esIq3Info?.length; i++) {
        if (props.selectedDataDetail?.esIq3Info[i]?.no === curRowNo) {
          setCurrentRecordIndex(i);
        }
      }
    }
  }, [
    props.selectedIQ3DataDetail,
    props.selectedDataDetail,
    props.type,
    props.currentRecordNo,
    props.activeTabKey,
    props?.isReCal,
    props.iQ3DataLst,
  ]);

  useEffect(() => {
    if (props?.tabOpen || props?.pmxMode) {
      setEditMode(props.editMode != undefined ? props.editMode : false);
    }
  }, [props.editMode]);

  const getProcesssPatternInfo = async () => {
    let kouteiPatternList = [];
    // 工程マスタデータ
    const patternLst = parameters?.processPattern;
    kouteiPatternList = patternLst?.filter((item) => item.class === ServiceClass.SheetMetal);
    setListData(kouteiPatternList);
    setKouteiSentakuPatternList(kouteiPatternList);
    // if (props.type === 'pmx') {
    //   if (props?.patternNo != 0 && props?.patternNo != undefined) {
    //     const selectedPatternInfo = kouteiPatternList?.filter((item) => item.id == props.patternNo);
    //     setProcessSelectedData(selectedPatternInfo[0]);
    //     setKouteiSentakuPatternNo(selectedPatternInfo[0]?.id);
    //   } else {
    //     let esIq3Info = props?.selectedDataDetail?.esIq3Info;
    //     let processSelect = esIq3Info?.length > 0 ? esIq3Info[0]?.processSelect : undefined;
    //     if (processSelect) {
    //       setProcessSelectedData(processSelect);
    //       setKouteiSentakuPatternNo(processSelect.id);
    //     }
    //     if (!Array.isArray(processSelect?.details) || processSelect.details.length <= 0) {
    //       const defaultPatternList = await getDefaultProcessPattern(1);

    //       processSelect.details = defaultPatternList;
    //     }
    //   }
    // }

    // 2025-09-25 IQX_WEBEST-463 パラメータの工程パターンにデータがない時、見積データの工程選択から装置が選べない。
    if (props.type === 'pmx') {
      if (props?.patternNo != 0 && props?.patternNo != undefined) {
        const selectedPatternInfo = kouteiPatternList?.filter((item) => item.id == props.patternNo);
        setProcessSelectedData(selectedPatternInfo[0]);
        setKouteiSentakuPatternNo(selectedPatternInfo[0]?.id);
      } else {
        let esIq3Info = props?.selectedDataDetail?.esIq3Info;
        let processSelect = esIq3Info?.length > 0 ? esIq3Info[0]?.processSelect : undefined;

        if (processSelect) {
          if (
            !Array.isArray(processSelect.details) ||
            processSelect.details.length === 0 ||
            processSelect.details.some((d) => d.deviceId === 0)
          ) {
            const defaultPatternList = await getDefaultProcessPattern(IQ3ClassNumber);
            processSelect.details = defaultPatternList;
          }

          setProcessSelectedData(processSelect);
          setKouteiSentakuPatternNo(processSelect.id);
        }
      }
    } else {
      // 2025-08-25 IQX_WEBEST-463 パラメータの工程パターンにデータがない時、見積データの工程選択から装置が選べない。
      let processSelect = props?.selectedIQ3DataDetail?.processSelect;
      if (!Array.isArray(processSelect?.details) || processSelect.details.length <= 0) {
        const currentServiceClass = getCurrentServiceClass();
        const defaultPatternList = await getDefaultProcessPattern(currentServiceClass);
        processSelect.details = defaultPatternList;
      }
      setProcessSelectedData(processSelect);
      setKouteiSentakuPatternNo(processSelect?.id);
    }

    setDeviceMasterInfo(parameters?.device);
    setProcessMasterInfo(parameters?.process);
    setClientInfo(parameters?.client);
  };

  // 2025-08-25 IQX_WEBEST-463 パラメータの工程パターンにデータがない時、見積データの工程選択から装置が選べない。
  const getDefaultProcessPattern = async (currentServiceClass) => {
    let processMasterData = [];
    let processList = [];
    let deviceList = [];
    let multiProcessList = [];
    const processMaster = await getProcessInfo(); // 工程マスタデータ
    const deviceMasterInfo = await getDeviceInfo(0, 0, currentServiceClass, 'ASC', 'id', {}); // 装置マスタデータ
    let deviceMaster = [];
    if (deviceMasterInfo) {
      deviceMaster = deviceMasterInfo?.data;
    }

    //工程マスターデータにより種類選択ボックスデータ準備
    if (currentServiceClass === ServiceClass.Parent) {
      // 親部品の場合、
      processMasterData = processMaster?.filter((item) => item.class === ServiceClass.Parent);
    } else if (currentServiceClass === ServiceClass.SheetMetal) {
      // 板金の場合、
      processMasterData = processMaster?.filter((item) => item.class === ServiceClass.SheetMetal);
    } else if (currentServiceClass === ServiceClass.Beams) {
      // 形鋼の場合、
      processMasterData = processMaster?.filter((item) => item.class === ServiceClass.Beams);
    }
    deviceList = deviceMaster?.filter((item) => processMasterData?.filter((process) => process?.id == item?.processId));
    if (deviceList !== null && processMasterData !== null) {
      processMasterData?.forEach((master) => {
        if (master.isAdditional) {
          // 追加タイプの場合、
          let processDetailTypes = master.details?.processDetailTypes;
          for (let j = 0; j < processDetailTypes?.length; j++) {
            // 2025-05-30 工程積算の検査と梱包の段取金額/時間の編集データの金額と時間が調整できません。
            let device = deviceList
              ?.filter((item) => item.processId === master.id && item?.info?.isUsed === true)
              ?.filter((device) => device?.details?.addProcessTypeId === processDetailTypes[j]?.id);

            multiProcessList = [];
            multiProcessList.push({
              processNo: 1,
              processDetailGroup: ProcessDetailGroup.None,
              processDetailTypeId: processDetailTypes[j]?.id,
            });
            processList.push({
              processId: master?.id,
              deviceId: device?.length > 0 ? device?.[0].id : 0,
              isUsedForCalc: false,
              multiprocesses: multiProcessList,
            });
          }
        } else {
          // 2025-05-30 工程積算の検査と梱包の段取金額/時間の編集データの金額と時間が調整できません。
          let device = deviceList?.filter((item) => item.processId == master.id && item?.info?.isUsed === true)?.[0];
          multiProcessList = [];
          for (let i = 1; i <= master?.details?.processQty; i++) {
            multiProcessList.push({
              processNo: i,
              processDetailGroup: ProcessDetailGroup.None,
              processDetailTypeId: 0,
            });
          }
          processList.push({
            processId: master?.id,
            deviceId: device?.id ? device?.id : 0, // 2025-05-30 工程積算の検査と梱包の段取金額/時間の編集データの金額と時間が調整できません。
            isUsedForCalc: false,
            multiprocesses: multiProcessList,
          });
        }
      });
    }

    return processList;
  };

  const updateKouteiSentakuInfo = async (selectedProcessPattern, list) => {
    setKouteiSentakuPatternNo(selectedProcessPattern?.id);
    setProcessSelectedData(selectedProcessPattern);
    setKouteiSentakuPatternList(list);
    if (props.type === 'pmx') {
      props.updateSelectedPatternNo(selectedProcessPattern?.id);
      const updatedLists = props.selectedDataDetail?.esIq3Info?.map((item) => ({
        ...item,
        processSelect: selectedProcessPattern,
      }));
      props.selectedDataDetail.esIq3Info = updatedLists;

      // props.updatedSelectedData(updatedLists);
    }

    //マイン見積データに板金工程選択更新
    if (props.selectedDataDetail.esIq3Info[currentRecordIndex]) {
      let currentPattern = JSON.parse(JSON.stringify({ ...props.selectedDataDetail.esIq3Info[currentRecordIndex] }));
      let processSelect = initProcessSelect(selectedProcessPattern);
      currentPattern.processSelect.id = processSelect?.id;
      currentPattern.processSelect.name = processSelect?.name;
      currentPattern.processSelect.details = processSelect?.details;
      currentPattern.processSelect.modified = processSelect?.modified;

      props.selectedDataDetail.esIq3Info[currentRecordIndex] = currentPattern;

      // ブランクの場合
      let blankProcess = getProcessRecord(
        ServiceClass.SheetMetal,
        [WorkType.SmBlankLaser, WorkType.SmBlankPunch, WorkType.SmBlankCombi], // レーザー、パンチ、複合機
        parameters?.process
      );
      // 板金工程選択にブランクを使用している場合、
      let usedBlankProcess = props.selectedDataDetail.esIq3Info[currentRecordIndex].processSelect.details?.find(
        (selectItem) =>
          selectItem.isUsedForCalc && blankProcess?.findIndex((item) => item.id === selectItem.processId) > -1
      );
      // 使用している装置の情報を取得する
      let usedDeviceInfo = parameters?.device?.find((device) => device.id === usedBlankProcess?.deviceId);

      // 装置がある場合、
      if (usedDeviceInfo) {
        // 装置から材料配置情報
        let materialArrange = usedDeviceInfo?.details?.materialArrange;
        props.selectedDataDetail.esIq3Info[currentRecordIndex].grabbingX = materialArrange?.graspAllowanceX;
        props.selectedDataDetail.esIq3Info[currentRecordIndex].grabbingY = materialArrange?.graspAllowanceY;
        props.selectedDataDetail.esIq3Info[currentRecordIndex].pierWidthX = materialArrange?.xWidth;
        props.selectedDataDetail.esIq3Info[currentRecordIndex].pierWidthY = materialArrange?.yWidth;
        props.selectedDataDetail.esIq3Info[currentRecordIndex].worlRangeX = materialArrange?.workRangeX;
        props.selectedDataDetail.esIq3Info[currentRecordIndex].worlRangeY = materialArrange?.workRangeY;
      } else {
        // 装置がない場合、材料配置情報をリセット
        props.selectedDataDetail.esIq3Info[currentRecordIndex].grabbingX = 0;
        props.selectedDataDetail.esIq3Info[currentRecordIndex].grabbingY = 0;
        props.selectedDataDetail.esIq3Info[currentRecordIndex].pierWidthX = 0;
        props.selectedDataDetail.esIq3Info[currentRecordIndex].pierWidthY = 0;
        props.selectedDataDetail.esIq3Info[currentRecordIndex].worlRangeX = 0;
        props.selectedDataDetail.esIq3Info[currentRecordIndex].worlRangeY = 0;
      }
    }

    // 現在の板金データに工程選択情報更新
    if (props.type !== 'pmx') {
      props.updateProcessSelectOfSelectedData(selectedProcessPattern);
      // IQX_WEBEST-323 新規処理の前回値の採用
      let userSetting = props.selectedDataDetail?.estimateProducts?.calcParameters?.settings?.userSettings;
      if (userSetting?.length > 0) userSetting = userSetting[0];
      if (userSetting !== null) {
        if (userSetting.users?.newSmInitialInfo?.iq3ProcessPatternId !== undefined) {
          userSetting.users.newSmInitialInfo.iq3ProcessPatternId = selectedProcessPattern.id;
          await updateUserSetting(userSetting, 0);
        }
      }
    }
  };

  const updateSelectedData = (selectedPart) => {
    props.updateSelectedData(selectedPart);
  };

  // 工程マスタのレコードIDを取得する
  const getProcessRecord = (classId, processTypes, mstInfo) => {
    // 選択された、種別と工程より工程マスタレコードIDを得る
    let mstRecordInfo = [...mstInfo]?.filter(
      (item) => item?.class === classId && processTypes?.findIndex((workType) => workType === item?.workType) > -1
    );
    return mstRecordInfo;
  };

  const updateIsPrepareInfoFlg = (flg) => {
    props?.updateIsPrepareInfoFlg(flg);
  };

  useImperativeHandle(
    ref,
    () => ({
      getKouteiSentakuPatternNo: () => {
        return kouteiSentakuPatternNo;
      },
      getKouteiSentakuPatternList: () => {
        return kouteiSentakuPatternList;
      },
      getProcessSelectedData: () => {
        return processSelectedData;
      },
    }),
    [kouteiSentakuPatternNo, kouteiSentakuPatternList, processSelectedData]
  );

  // 工程パターンのルートパスで「親部品／板金」の判断
  const getCurrentServiceClass = () => {
    const currentRoute = location.pathname;
    if (currentRoute?.includes('parent')) {
      return ServiceClass.Parent;
    } else if (currentRoute?.includes('iq3')) {
      return ServiceClass.SheetMetal;
    } else if (currentRoute?.includes('iq5')) {
      return ServiceClass.Beams;
    }
  };

  // 見積データ画面から工程パターン登録
  const updatePatternList = (data) => {
    setListData(data);

    // 2025-09-25 IQX_WEBEST-463 パラメータの工程パターンにデータがない時、見積データの工程選択から装置が選べない。
    const classVal = IQ3ClassNumber;

    const parameters = props?.selectedDataDetail?.estimateProducts?.calcParameters?.parameters;

    if (parameters) {
      const existingList = parameters.processPattern || [];

      const preservedList = existingList.filter((item) => item.class !== classVal);

      const updatedClass0 = data.filter((item) => item.class === classVal);

      const mergedProcessPattern = [...preservedList, ...updatedClass0];

      parameters.processPattern = mergedProcessPattern;
      props.selectedDataDetail.estimateProducts.calcParameters.parameters = {
        ...parameters,
        processPattern: mergedProcessPattern,
      };
    }
  };

  return (
    <>
      {/* 2025-09-25 IQX_WEBEST-463 パラメータの工程パターンにデータがない時、見積データの工程選択から装置が選べない。 */}
      {/* {props.tabOpen || props?.pmxMode ? ( */}
      {(props.tabOpen || props?.pmxMode) &&
        processSelectedData &&
        Array.isArray(processSelectedData.details) &&
        processSelectedData.details.length > 0 && (
          <div style={{ paddingTop: 0 }}>
            <ProcessPatternForm
              ref={patternformRef}
              selectedData={processSelectedData}
              listData={listData}
              editMode={props.editMode}
              page={patternPage[1]}
              isParameter={false}
              updateKouteiSentakuInfo={updateKouteiSentakuInfo}
              kouteiSentakuEditMode={editMode}
              iq3PartList={iq3List}
              childPartNo={props.selectedIQ3DataDetail != undefined ? props.selectedIQ3DataDetail.no : 1}
              updateSelectedData={updateSelectedData}
              pmxMode={props.pmxMode}
              processMasterData={processMasterInfo}
              deviceMasterData={deviceMasterInfo}
              clientMasterData={clientInfo}
              updateIsPrepareInfoFlg={updateIsPrepareInfoFlg}
              updatePatternList={updatePatternList}
              patternInsertClass={props?.patternInsertClass}
              setIQ3PatternList={props?.setIQ3PatternList}
            />
          </div>
        )}
    </>
  );
});

export default IQ3KouteiSentaku;
